// import React, { useState, useEffect, useRef } from "react";
// import "./Home.css";
// import { MapContainer, TileLayer, GeoJSON, Marker, Popup,LayersControl } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";
// import Forecast from "../Forecast/Forecast";
// import HistoricalStatistics from "../HistoricalStatistics/HistoricalStatistics";
// import { GiWhirlwind,GiCelebrationFire } from "react-icons/gi";
// import { MdLandslide, MdOutlineFlood } from "react-icons/md";
// import { RiEarthquakeFill } from "react-icons/ri";
// import { FaRoad } from "react-icons/fa";
// import { renderToStaticMarkup } from "react-dom/server"; // Convert React Icon to HTML
// import { FaCircleInfo } from "react-icons/fa6";
// import { Tooltip } from "react-tooltip";
// import { RiEarthquakeLine } from "react-icons/ri";

// // Configuring Leaflet default icon
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });



// const Home = () => {
//   const [legendVisible, setLegendVisible] = useState(false);
//   const [boundaryData, setBoundaryData] = useState(null);
//   const [muncipalityBoundry, setMuncipalityBoundry] = useState(null);
//   const [subMuncipalityBoundry, setSubMuncipalityBoundry] = useState(null);
//   const [sucoBoundaryData, setSucoBoundaryData] = useState(null);
//   const [activeBoundary, setActiveBoundary] = useState("country");
//   const [selectedMarkers, setSelectedMarkers] = useState({});
//   const [expandedEvent, setExpandedEvent] = useState("Cyclone");
//     const position = [-8.8747, 125.7275];
//   const legendRef = useRef(null);
  
//   const markers = [
//     {
//       name: "Cyclone",
//       src: <GiWhirlwind />      ,
//       icon_name : GiWhirlwind,
//       lat: -9.2,
//       lon: 126.2,
//       details: <span><strong className="underline-text">Cyclone</strong> <br/> <b> Name : </b>Seroja <br/> <b>Wind Speed :</b> 120 kt  <br/> <b>Date & Time : </b>{new Date().toLocaleString()}</span>,
//     },
//     {
//         name: "Cyclone",
//         src: <GiWhirlwind />      ,
//         icon_name : GiWhirlwind,
//         lat: -9.2,
//         lon: 125.2,
//         details: <span><strong className="underline-text">Cyclone</strong><br/><b> Name : </b>Seroja-2 <br/> <b>Wind Speed :</b> 78 kt  <br/> <b>Date & Time : </b>{new Date().toLocaleString()}</span>,
//       },
//     {
//       name: "Landslide",
//       src: <MdLandslide />      ,
//       icon_name : MdLandslide,
//       lat: -8.6,
//       lon: 126.62,
//       details : <span><strong className="underline-text">Landslide</strong> <br/>  <b>Location : </b>Viqueque, Timor-Leste <br/>  <b>Date & Time :</b> {new Date().toLocaleString()}</span>,
//     },
//     {
//       name: "Urban Flood",
//       src: <MdOutlineFlood />,
//       icon_name : MdOutlineFlood,
//       lat: -8.9,
//       lon: 125.8,
//       details : <span><strong className="underline-text" >Urban Flood</strong> <br/>  <b>Location :</b> Manufahi, Timor-Leste<br/> <b>Rainfall :</b> 65 mm <br/> <b>Date & Time : </b>{new Date().toLocaleString()}</span>,
//     },
//     {
//       name: "Earthquake",
//       //src: '/Earthquake/recent.png',
//       src : <RiEarthquakeLine/>,
//       icon_name : RiEarthquakeFill,
//       lat: -9.2675,
//       lon: 124.2860,
//       details : <span> <strong className="underline-text">Earthquake</strong> <br/>  <b>Location : </b> :  Nitibe, Oecusse,  Timor Leste<br/> <b>Longitude : </b> 124.2860 <br/> <b>Latitude : </b> -9.2675 <br/> <b>Magnitude : </b>5.0 mb <br/> <b>Depth : </b> 42KM <br/> <b>Date & Time : </b>{new Date().toLocaleString()}</span>,
//     },
//     {
//       name: "Fire",
//       src: <GiCelebrationFire/>,
//       icon_name : GiCelebrationFire,
//       lat: -8.5,
//       lon: 126.95,
//       //details : <span><strong>Fire</strong> <br/> <b>Location : </b>  Fuat, Iliomar, Lautém Timor Leste<br/> <b>Sub Municipality:</b> Iliomar<br/> <b>Municipality:</b> Lautém <br/> <b>Type:</b> Motorized Accident <br/><b>Road Condition:</b> Sharp Curved <br/><b>Blackspot:</b> No <br/> <b>Date & Time : </b>{new Date().toLocaleString()}</span>,
//       details : <span><strong className="underline-text">Fire</strong> <br/> <b>Location : </b>  Fuat, Iliomar, Lautém, Timor Leste<br/> <b>Date & Time : </b>{new Date().toLocaleString()}</span>,
//     },
//     {
//       name: "Road Accident",
//       icon_name : FaRoad,
//       src: <FaRoad/>,
//       lat: -8.13,
//       lon: 125.57,
//       //details : <span><strong className="underline-text">Road Accident</strong> <br/> <strong>Location</strong> <br/> <b>Sub Municipality:</b> Atauro<br/> <b>Municipality:</b> Biqueli <br/> <b>Date & Time :</b> {new Date().toLocaleString()}</span>,
//       details : <span><strong className="underline-text">Road Accident</strong> <br/> <strong>Location</strong> Atauro, Biqueli , Timor-Leste<br/> <b>Type:</b> Motorized Accident <br/><b>Road Condition:</b> Sharp Curved <br/><b>Blackspot:</b> No <br/><b>Date & Time :</b> {new Date().toLocaleString()}</span>,
//     },
//   ];

//   useEffect(() => {
//     const initialMarkers = markers.reduce((acc, marker) => {
//       acc[marker.name] = true;
//       return acc;
//     }, {});
//     setSelectedMarkers(initialMarkers);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//     useEffect(() => {
//     // Load the GeoJSON boundary data
//         fetch("/DATA/OSMbased_adm0_boundary.json")
//         .then((response) => response.json())
//         .then((data) => setBoundaryData(data))
//         .catch((error) => console.error("Error loading boundary data:", error));
//     }, []);

//     useEffect(() => {
//         fetch("/DATA/OSMbased_adm1_boundary.json")
//         .then((response) => response.json())
//         .then((data) => setMuncipalityBoundry(data))
//         .catch((error) => console.error("Error loading boundary data:", error));
//     }, []);
    
//     useEffect(() => {
//         fetch("/DATA/OSMbased_adm2_boundary.json")
//         .then((response) => response.json())
//         .then((data) => setSubMuncipalityBoundry(data))
//         .catch((error) => console.error("Error loading boundary data:", error));
//     }, []);

//     useEffect(() => {
//         fetch("/DATA/Suco.json")
//         .then((response) => response.json())
//         .then((data) => setSucoBoundaryData(data))
//         .catch((error) => console.error("Error loading boundary data:", error));
//     }, []);

//   const loadGeoJSON = (url, type) => {
//     setBoundaryData(null);
//     setActiveBoundary(type);

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }
//         return response.json();
//       })
//       .then((data) => {
//         setBoundaryData(data);
//       })
//       .catch((error) => console.error("Error loading GeoJSON:", error));
//   };

//   useEffect(() => {
//     loadGeoJSON(
//       `${process.env.PUBLIC_URL}/DATA/OSMbased_adm0_boundary.json`,
//       "country"
//     );
//   }, []);

//   const boundaryStyle = {
//     color: "#000FFF",
//     weight: 1,
//     fillOpacity: 0,
//   };

//   const onEachFeature = (feature, layer) => {
//     let popupContent = "";
//     if (activeBoundary === "country" && feature.properties) {
//       const { ADM0, Municipio, PostoAdmin, Sucos, Aldeias } =
//         feature.properties;
//       popupContent = `
//         <b>🗺️ Country:</b> ${ADM0 || "N/A"}<br />
//         <b>🏙️ Municipalities:</b> ${Municipio || "N/A"}<br />
//         <b>📍 PostoAdmin:</b> ${PostoAdmin || "N/A"}<br />
//         <b>🏘️ Sucos:</b> ${Sucos || "N/A"}<br />
//         <b>🏡 Aldeias:</b> ${Aldeias || "N/A"}<br />
//       `;
//     } else if (activeBoundary === "municipality" && feature.properties) {
//       const { ADM1, area_sqkm, Population, Male_Pop, Female_Pop } =
//         feature.properties;
//       popupContent = `
//         <b>🏙️ Municipality:</b> ${ADM1 || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${area_sqkm || "N/A"}<br />
//         <b>👥 Population:</b> ${Population || "N/A"}<br />
//         <b>👨 Male Population:</b> ${Male_Pop || "N/A"}<br />
//         <b>👩 Female Population:</b> ${Female_Pop || "N/A"}<br />
//       `;
//     } else if (activeBoundary === "sub-municipality" && feature.properties) {
//       const { ADM2, ADM1, area_sqkm } = feature.properties;
//       popupContent = `
//         <b>🏘️ Sub-Municipality:</b> ${ADM2 || "N/A"}<br />
//         <b>🏙️ Municipality:</b> ${ADM1 || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${area_sqkm || "N/A"}<br />
//       `;
//     }else if (activeBoundary === "suco" && feature.properties) {
//       const { SUCO, SHAPE_Leng, SHAPE_Area } = feature.properties;
//       popupContent = `
//         <b>🏘️ Suco:</b> ${ SUCO || "N/A"}<br />
//         <b>🏙️ Length:</b> ${SHAPE_Leng || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${SHAPE_Area || "N/A"}<br />
//       `;
//     }
//     layer.bindPopup(popupContent);
//     console.log(feature.properties);
//     layer.on({
//       popupopen: () => {
//         layer.setStyle({ fillOpacity: 0.5 });
//       },
//       popupclose: () => {
//         layer.setStyle({ fillOpacity: 0 });
//       },
//     });
//   };

//   const onEachFeatureCountry = (feature, layer) => {
//     let popupContent = "";
//     const { ADM0, Municipio, PostoAdmin, Sucos, Aldeias } = feature.properties;
//       popupContent = `
//         <b>🗺️ Country:</b> ${ADM0 || "N/A"}<br />
//         <b>🏙️ Municipalities:</b> ${Municipio || "N/A"}<br />
//         <b>📍 PostoAdmin:</b> ${PostoAdmin || "N/A"}<br />
//         <b>🏘️ Sucos:</b> ${Sucos || "N/A"}<br />
//         <b>🏡 Aldeias:</b> ${Aldeias || "N/A"}<br />
//       `;
//       layer.bindPopup(popupContent);
//       layer.on({
//         popupopen: () => {
//           layer.setStyle({ fillOpacity: 0.5 });
//         },
//         popupclose: () => {
//           layer.setStyle({ fillOpacity: 0 });
//         },
//       });
//   }
//   const onEachFeatureMuni = (feature, layer) => {
//     let popupContent = "";
//     const { ADM1, area_sqkm, Population, Male_Pop, Female_Pop } = feature.properties;
//         popupContent = `
//         <b>🏙️ Municipality:</b> ${ADM1 || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${area_sqkm || "N/A"}<br />
//         <b>👥 Population:</b> ${Population || "N/A"}<br />
//         <b>👨 Male Population:</b> ${Male_Pop || "N/A"}<br />
//         <b>👩 Female Population:</b> ${Female_Pop || "N/A"}<br />
//       `;
//       layer.bindPopup(popupContent);
//       layer.on({
//         popupopen: () => {
//           layer.setStyle({ fillOpacity: 0.5 });
//         },
//         popupclose: () => {
//           layer.setStyle({ fillOpacity: 0 });
//         },
//       });
//   }
//   const onEachFeatureSuco = (feature, layer) => {
//     let popupContent = "";
//     const { SUCO, SHAPE_Leng, SHAPE_Area } = feature.properties;
//     popupContent = `
//         <b>🏘️ Suco:</b> ${ SUCO || "N/A"}<br />
//         <b>🏙️ Length:</b> ${SHAPE_Leng || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${SHAPE_Area || "N/A"}<br />
//       `;
//       layer.bindPopup(popupContent);
//       layer.on({
//         popupopen: () => {
//           layer.setStyle({ fillOpacity: 0.5 });
//         },
//         popupclose: () => {
//           layer.setStyle({ fillOpacity: 0 });
//         },
//       });
//   }
//   const onEachFeatureSubMuni = (feature, layer) => {
//     let popupContent = "";
//     const { ADM2, ADM1, area_sqkm } = feature.properties;
//       popupContent = `
//         <b>🏘️ Sub-Municipality:</b> ${ADM2 || "N/A"}<br />
//         <b>🏙️ Municipality:</b> ${ADM1 || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${area_sqkm || "N/A"}<br />
//       `;
//       layer.bindPopup(popupContent);
//       layer.on({
//         popupopen: () => {
//           layer.setStyle({ fillOpacity: 0.5 });
//         },
//         popupclose: () => {
//           layer.setStyle({ fillOpacity: 0 });
//         },
//       });
//   }
//   // Close legend when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (legendRef.current && !legendRef.current.contains(event.target)) {
//         setLegendVisible(false);
//       }
//     };

//     if (legendVisible) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [legendVisible]);
//   const toggleDetails = (eventName) => {
//     setExpandedEvent(expandedEvent === eventName ? null : eventName);
//   };
  

//   // Helper function to create custom Leaflet icon
//   const createCustomIcon = (IconComponent) => {
//     const iconMarkup = renderToStaticMarkup(
//       <div style={{ fontSize: "32px" }}>
//         <IconComponent />
//       </div>
//     );
//     return L.divIcon({
//       html: iconMarkup,
//       className: "custom-leaflet-icon",
//     });
//   };

//   const Legend = () => {
//       return (
//           <div className="latest_event_legend">
//               <div><GiWhirlwind /> Cyclone</div>
//               <div><MdLandslide /> Landslide</div>
//               <div><MdOutlineFlood /> Flood</div>
//               {/* <div><img src="/Earthquake/recent.png" width={"20px"}/> Earthquake</div> */}
//               <div><RiEarthquakeLine /> Earthquake</div>
//               <div><GiCelebrationFire/> Fire</div>
//               <div><FaRoad />  RoadAccident</div>
//           </div>
//       );
//   };
//   const markerRefs = useRef([]);
//   const handleTitleClick = (index) => {
//     // Open the respective marker popup
//     markerRefs.current[index].openPopup();
//   };
  
//   return (
//     <>
//         <Forecast/>
//       <div className="map">
//         <div className="map-home-container">
//           <MapContainer
//             center={position}
//             zoom={8}
//             className="leaflet-home"
//             zoomControl={false}
//             scrollWheelZoom={false}
//             dragging={false}
//             doubleClickZoom={false}
//             interactive={false}
//           >
//             <div className="map-date">
//               Active Disaster Events 
//             </div>

//             {/* <TileLayer
//               url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//             /> */}
//             <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//             {/* {boundaryData && (
//               <GeoJSON
//                 data={boundaryData}
//                 style={boundaryStyle}
//                 onEachFeature={onEachFeature}
//               />
//             )} */}
          
//             {markers.map((marker, index) => {
//                 if(marker.name === 'Earthquakes'){
//                     const icon = L.icon({
//                         iconUrl: "/Earthquake/recent.png",
//                         iconSize: [30, 30], 
//                     }) ;
//                     return selectedMarkers[marker.name] ? (
//                         <Marker
//                           key={index}
//                           position={[marker.lat, marker.lon]}
//                           icon={icon}
//                         >
//                           <Popup><span>{marker.details}</span></Popup>
//                         </Marker>
//                       ) : null;
//                 } else {
//                     return selectedMarkers[marker.name] ? (
                
//                         <Marker
//                           key={index}
//                           position={[marker.lat, marker.lon]}
//                           icon={createCustomIcon(marker.icon_name)}
//                         >
//                           <Popup>{marker.details}</Popup>
//                         </Marker>
//                       ) : null;
//                 }
              
//             })}
//             <LayersControl position="topright" className="always-open">
//                 <LayersControl.BaseLayer name="Country" checked >
//                     {boundaryData && (
//                         <GeoJSON
//                             data={boundaryData}
//                             style={boundaryStyle}
//                             onEachFeature={onEachFeatureCountry}
//                         />
//                     )}
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer name="Municipality - 14" >
//                     {muncipalityBoundry && (
//                         <GeoJSON
//                             data={muncipalityBoundry}
//                             style={boundaryStyle}
//                             onEachFeature={onEachFeatureMuni}
//                         />
//                     )}
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer name="Sub Municipality - 71" >
//                     {subMuncipalityBoundry && (
//                         <GeoJSON
//                             data={subMuncipalityBoundry}
//                             style={boundaryStyle}
//                             onEachFeature={onEachFeatureSubMuni}
//                         />
//                     )}
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer name="Sucos - 452" >
//                     {sucoBoundaryData && (
//                         <GeoJSON
//                             data={sucoBoundaryData}
//                             style={boundaryStyle}
//                             onEachFeature={onEachFeatureSuco}
//                         />
//                     )}
//                 </LayersControl.BaseLayer>
//             </LayersControl>
//             <Legend position="bottomleft" />
           

//           </MapContainer>
//             {/* Custom Icon Container (Positioned on the left-middle of the map) */}
            
//           {/* Event Count Box */}
//           <div className="event-box">
//             <div className="text-title">Latest Events <FaCircleInfo data-tooltip-id="info-tooltip" /></div>
//             <Tooltip id="info-tooltip" className="home-tooltip" place="bottom" effect="">
//                 The latest event shows last 24 hours data.
//             </Tooltip>


//             <div className="event-list">
//                 <div className="event-item">
//                     <div className="event-main high" >
//                         <div className="event-details">
//                             Cyclone
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                         <ol className="cyclone_events_latest">
//                             <li>Name : Seroja <br/> Date: {new Date().toLocaleString()} <br/> Wind Speed : 120 kt</li>
//                             <li>Name : Seroja -2  <br/> Date: {new Date().toLocaleString()} <br/> Wind Speed : 78 kt</li>
//                         </ol>
//                     </div>
                    
//                 </div>
//                 <div className="event-item">
//                     <div className="event-main"  >
//                         <div className="event-details">
//                             Landslide
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                             <span>Location : Viqueque, Timor-Leste <br/> Date & Time: {new Date().toLocaleString()}</span>
//                         </div>
//                 </div>
//                 <div className="event-item">
//                     <div className="event-main high" >
//                         <div className="event-details">
//                             Earthquake
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                             <span>Location : Nitibe, Oecusse,  Timor Leste <br/> 
//                             Magnitude : 5.0 mb <br/> Depth : 42KM <br/>
//                             Longitude : 124.2860<br/>
//                             Latitude : -9.2675<br/>
//                             Date & Time: {new Date().toLocaleString()}</span>
//                         </div>
//                 </div>
//                 <div className="event-item">
//                     <div className="event-main low"  >
//                         <div className="event-details">
//                             Urban Flood
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                             <span>Location : Viqueque, Timor-Leste <br/> Rainfall : 65 mm <br/>Date & Time: {new Date().toLocaleString()}</span>
//                         </div>
//                 </div>
//                 <div className="event-item">
//                     <div className="event-main medium"  >
//                         <div className="event-details">
//                             Road Accident
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                             <span>Location : Atauro, Biqueli , Timor-Leste <br/> Type : Motorized Accident <br/> Road Condition : Sharp Curved<br/> 
//                             Blackspot : No <br/>
//                             Date & Time: {new Date().toLocaleString()}</span>
//                         </div>
//                 </div>
//                 <div className="event-item">
//                     <div className="event-main moderate" >
//                         <div className="event-details">
//                             Fire
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                             <span>Location : Fuat, Iliomar, Lautém, Timor Leste <br/> Date & Time: {new Date().toLocaleString()}</span>
//                         </div>
//                 </div>
//             </div>
//           </div>
//             {/* <div className="overviewdashboardpart2">
//                   <div className="activitytile">
//                     <h1 className="activitytile-title">Current Activities</h1>
//                     <div className="small-tile">
//                     {markers.map((activity, index) => (
//                         <div 
//                           key={index} 
//                           className="activitytile"
//                           onClick={() => handleTitleClick(index + markers.length)}
//                         >
//                           <h2 className="activity-heading">{activity.nameOfEvent}</h2>
//                           <p className="activity-details">
//                             Date and Time: {moment.utc(activity.dateTime).tz('Asia/Dili').format('MMMM DD, YYYY [at] h:mm A')},
//                             Location: {activity.location}
//                           </p>
//                         </div>
//                       ))}
//                     </div>
          
//                   </div>
//             </div> */}
//         </div>
//       </div>
//       <HistoricalStatistics/>
//     </>
//   );
// };
// export default Home;



// import React, { useState, useEffect, useRef } from "react";
// import "./Home.css";
// import { MapContainer, TileLayer, GeoJSON, Marker, Popup,LayersControl } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";
// import Forecast from "../Forecast/Forecast";
// import HistoricalStatistics from "../HistoricalStatistics/HistoricalStatistics";
// import { GiWhirlwind,GiCelebrationFire } from "react-icons/gi";
// import { MdLandslide, MdOutlineFlood } from "react-icons/md";
// import { FaRoad } from "react-icons/fa";
// import { renderToStaticMarkup } from "react-dom/server"; // Convert React Icon to HTML
// import { FaCircleInfo } from "react-icons/fa6";
// import { Tooltip } from "react-tooltip";
// import { RiEarthquakeLine } from "react-icons/ri";
// import  DateFormat from "../../../DateFormat";

// // Configuring Leaflet default icon
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });



// const Home = () => {
//   const [legendVisible, setLegendVisible] = useState(false);
//   const [boundaryData, setBoundaryData] = useState(null);
//   const [muncipalityBoundry, setMuncipalityBoundry] = useState(null);
//   const [subMuncipalityBoundry, setSubMuncipalityBoundry] = useState(null);
//   const [sucoBoundaryData, setSucoBoundaryData] = useState(null);
//   const [activeBoundary, setActiveBoundary] = useState("country");
//   const [selectedMarkers, setSelectedMarkers] = useState({});
//   //const [expandedEvent, setExpandedEvent] = useState("Cyclone");
//     const position = [-8.8747, 125.7275];
//   const legendRef = useRef(null);
  
//   const markers = [
//     {
//       name: "Cyclone",
//       src: <GiWhirlwind />      ,
//       //icon_name : GiWhirlwind,
//       icon_name : 'Dashboard/Legends/cyclone.gif',
//       lat: -9.2,
//       lon: 126.2,
//       details: <span><strong className="underline-text">Cyclone</strong> <br/> <b> Name : </b>Seroja <br/> <b>Wind Speed :</b> 120 kt  <br/> <b>Date & Time : </b>{<DateFormat date={new Date()} format="dmytime" />}</span>,
//     },
//     {
//         name: "Cyclone",
//         src: <GiWhirlwind />      ,
//         // icon_name : GiWhirlwind,
//         icon_name : 'Dashboard/Legends/cyclone.gif',
//         lat: -9.2,
//         lon: 125.2,
//         details: <span><strong className="underline-text">Cyclone</strong><br/><b> Name : </b>Seroja-2 <br/> <b>Wind Speed :</b> 78 kt  <br/> <b>Date & Time : </b>{<DateFormat date={new Date()} format="dmytime" />}</span>,
//       },
//     {
//       name: "Landslide",
//       src: <MdLandslide />      ,
//       //icon_name : MdLandslide,
//       icon_name : 'Dashboard/Legends/landslide.gif',
//       lat: -8.6,
//       lon: 126.62,
//       details : <span><strong className="underline-text">Landslide</strong> <br/>  <b>Location : </b>Viqueque, Timor-Leste <br/>  <b>Date & Time :</b> {<DateFormat date={new Date()} format="dmytime" />}</span>,
//     },
//     {
//       name: "Urban Flood",
//       src: <MdOutlineFlood />,
//       //icon_name : MdOutlineFlood,
//       icon_name : 'Dashboard/Legends/flood.gif',
//       lat: -8.9,
//       lon: 125.8,
//       details : <span><strong className="underline-text" >Urban Flood</strong> <br/>  <b>Location :</b> Manufahi, Timor-Leste<br/> <b>Rainfall :</b> 65 mm <br/> <b>Date & Time : </b>{<DateFormat date={new Date()} format="dmytime" />}</span>,
//     },
//     {
//       name: "Earthquake",
//       //src: '/Earthquake/recent.png',
//       src : <RiEarthquakeLine/>,
//       //icon_name : RiEarthquakeFill,
//       icon_name : 'Dashboard/Legends/earthquake.gif',
//       lat: -9.2675,
//       lon: 124.2860,
//       details : <span> <strong className="underline-text">Earthquake</strong> <br/>  <b>Location : </b> :  Nitibe, Oecusse,  Timor Leste<br/> <b>Longitude : </b> 124.2860 <br/> <b>Latitude : </b> -9.2675 <br/> <b>Magnitude : </b>5.0 mb <br/> <b>Depth : </b> 42KM <br/> <b>Date & Time : </b>{<DateFormat date={new Date()} format="dmytime" />}</span>,
//     },
//     {
//       name: "Fire",
//       src: <GiCelebrationFire/>,
//       //icon_name : GiCelebrationFire,
//       icon_name : 'Dashboard/Legends/fire.gif',
//       lat: -8.5,
//       lon: 126.95,
//       //details : <span><strong>Fire</strong> <br/> <b>Location : </b>  Fuat, Iliomar, Lautém Timor Leste<br/> <b>Sub Municipality:</b> Iliomar<br/> <b>Municipality:</b> Lautém <br/> <b>Type:</b> Motorized Accident <br/><b>Road Condition:</b> Sharp Curved <br/><b>Blackspot:</b> No <br/> <b>Date & Time : </b>{new Date().toLocaleString()}</span>,
//       details : <span><strong className="underline-text">Fire</strong> <br/> <b>Location : </b>  Fuat, Iliomar, Lautém, Timor Leste<br/> <b>Date & Time : </b>{<DateFormat date={new Date()} format="dmytime" />}</span>,
//     },
//     {
//       name: "Road Accident",
//       //icon_name : FaRoad,
//       icon_name : 'Dashboard/Legends/roadaccident.gif',
//       src: <FaRoad/>,
//       lat: -8.13,
//       lon: 125.57,
//       //details : <span><strong className="underline-text">Road Accident</strong> <br/> <strong>Location</strong> <br/> <b>Sub Municipality:</b> Atauro<br/> <b>Municipality:</b> Biqueli <br/> <b>Date & Time :</b> {new Date().toLocaleString()}</span>,
//       details : <span><strong className="underline-text">Road Accident</strong> <br/> <strong>Location</strong> Atauro, Biqueli , Timor-Leste<br/> <b>Type:</b> Motorized Accident <br/><b>Road Condition:</b> Sharp Curved <br/><b>Blackspot:</b> No <br/><b>Date & Time :</b> {<DateFormat date={new Date()} format="dmytime" />}</span>,
//     },
//   ];

//   useEffect(() => {
//     const initialMarkers = markers.reduce((acc, marker) => {
//       acc[marker.name] = true;
//       return acc;
//     }, {});
//     setSelectedMarkers(initialMarkers);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//     useEffect(() => {
//     // Load the GeoJSON boundary data
//         fetch("/DATA/OSMbased_adm0_boundary.json")
//         .then((response) => response.json())
//         .then((data) => setBoundaryData(data))
//         .catch((error) => console.error("Error loading boundary data:", error));
//     }, []);

//     useEffect(() => {
//         fetch("/DATA/OSMbased_adm1_boundary.json")
//         .then((response) => response.json())
//         .then((data) => setMuncipalityBoundry(data))
//         .catch((error) => console.error("Error loading boundary data:", error));
//     }, []);
    
//     useEffect(() => {
//         fetch("/DATA/OSMbased_adm2_boundary.json")
//         .then((response) => response.json())
//         .then((data) => setSubMuncipalityBoundry(data))
//         .catch((error) => console.error("Error loading boundary data:", error));
//     }, []);

//     useEffect(() => {
//         fetch("/DATA/Suco.json")
//         .then((response) => response.json())
//         .then((data) => setSucoBoundaryData(data))
//         .catch((error) => console.error("Error loading boundary data:", error));
//     }, []);

//   const loadGeoJSON = (url, type) => {
//     setBoundaryData(null);
//     setActiveBoundary(type);

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }
//         return response.json();
//       })
//       .then((data) => {
//         setBoundaryData(data);
//       })
//       .catch((error) => console.error("Error loading GeoJSON:", error));
//   };

//   useEffect(() => {
//     loadGeoJSON(
//       `${process.env.PUBLIC_URL}/DATA/OSMbased_adm0_boundary.json`,
//       "country"
//     );
//   }, []);

//   const boundaryStyle = {
//     color: "#000FFF",
//     weight: 1,
//     fillOpacity: 0,
//   };

//   const onEachFeature = (feature, layer) => {
//     let popupContent = "";
//     if (activeBoundary === "country" && feature.properties) {
//       const { ADM0, Municipio, PostoAdmin, Sucos, Aldeias } =
//         feature.properties;
//       popupContent = `
//         <b>🗺️ Country:</b> ${ADM0 || "N/A"}<br />
//         <b>🏙️ Municipalities:</b> ${Municipio || "N/A"}<br />
//         <b>📍 PostoAdmin:</b> ${PostoAdmin || "N/A"}<br />
//         <b>🏘️ Sucos:</b> ${Sucos || "N/A"}<br />
//         <b>🏡 Aldeias:</b> ${Aldeias || "N/A"}<br />
//       `;
//     } else if (activeBoundary === "municipality" && feature.properties) {
//       const { ADM1, area_sqkm, Population, Male_Pop, Female_Pop } =
//         feature.properties;
//       popupContent = `
//         <b>🏙️ Municipality:</b> ${ADM1 || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${area_sqkm || "N/A"}<br />
//         <b>👥 Population:</b> ${Population || "N/A"}<br />
//         <b>👨 Male Population:</b> ${Male_Pop || "N/A"}<br />
//         <b>👩 Female Population:</b> ${Female_Pop || "N/A"}<br />
//       `;
//     } else if (activeBoundary === "sub-municipality" && feature.properties) {
//       const { ADM2, ADM1, area_sqkm } = feature.properties;
//       popupContent = `
//         <b>🏘️ Sub-Municipality:</b> ${ADM2 || "N/A"}<br />
//         <b>🏙️ Municipality:</b> ${ADM1 || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${area_sqkm || "N/A"}<br />
//       `;
//     }else if (activeBoundary === "suco" && feature.properties) {
//       const { SUCO, SHAPE_Leng, SHAPE_Area } = feature.properties;
//       popupContent = `
//         <b>🏘️ Suco:</b> ${ SUCO || "N/A"}<br />
//         <b>🏙️ Length:</b> ${SHAPE_Leng || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${SHAPE_Area || "N/A"}<br />
//       `;
//     }
//     layer.bindPopup(popupContent);
//     //console.log(feature.properties);
//     layer.on({
//       popupopen: () => {
//         layer.setStyle({ fillOpacity: 0.5 });
//       },
//       popupclose: () => {
//         layer.setStyle({ fillOpacity: 0 });
//       },
//     });
//   };

//   const onEachFeatureCountry = (feature, layer) => {
//     let popupContent = "";
//     const { ADM0, Municipio, PostoAdmin, Sucos, Aldeias } = feature.properties;
//       popupContent = `
//         <b>🗺️ Country:</b> ${ADM0 || "N/A"}<br />
//         <b>🏙️ Municipalities:</b> ${Municipio || "N/A"}<br />
//         <b>📍 PostoAdmin:</b> ${PostoAdmin || "N/A"}<br />
//         <b>🏘️ Sucos:</b> ${Sucos || "N/A"}<br />
//         <b>🏡 Aldeias:</b> ${Aldeias || "N/A"}<br />
//       `;
//       layer.bindPopup(popupContent);
//       layer.on({
//         popupopen: () => {
//           layer.setStyle({ fillOpacity: 0.5 });
//         },
//         popupclose: () => {
//           layer.setStyle({ fillOpacity: 0 });
//         },
//       });
//   }
//   const onEachFeatureMuni = (feature, layer) => {
//     let popupContent = "";
//     const { ADM1, area_sqkm, Population, Male_Pop, Female_Pop } = feature.properties;
//         popupContent = `
//         <b>🏙️ Municipality:</b> ${ADM1 || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${area_sqkm || "N/A"}<br />
//         <b>👥 Population:</b> ${Population || "N/A"}<br />
//         <b>👨 Male Population:</b> ${Male_Pop || "N/A"}<br />
//         <b>👩 Female Population:</b> ${Female_Pop || "N/A"}<br />
//       `;
//       layer.bindPopup(popupContent);
//       layer.on({
//         popupopen: () => {
//           layer.setStyle({ fillOpacity: 0.5 });
//         },
//         popupclose: () => {
//           layer.setStyle({ fillOpacity: 0 });
//         },
//       });
//   }
//   const onEachFeatureSuco = (feature, layer) => {
//     let popupContent = "";
//     const { SUCO, SHAPE_Leng, SHAPE_Area } = feature.properties;
//     popupContent = `
//         <b>🏘️ Suco:</b> ${ SUCO || "N/A"}<br />
//         <b>🏙️ Length:</b> ${SHAPE_Leng || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${SHAPE_Area || "N/A"}<br />
//       `;
//       layer.bindPopup(popupContent);
//       layer.on({
//         popupopen: () => {
//           layer.setStyle({ fillOpacity: 0.5 });
//         },
//         popupclose: () => {
//           layer.setStyle({ fillOpacity: 0 });
//         },
//       });
//   }
//   const onEachFeatureSubMuni = (feature, layer) => {
//     let popupContent = "";
//     const { ADM2, ADM1, area_sqkm } = feature.properties;
//       popupContent = `
//         <b>🏘️ Sub-Municipality:</b> ${ADM2 || "N/A"}<br />
//         <b>🏙️ Municipality:</b> ${ADM1 || "N/A"}<br />
//         <b>📏 Area (sq km):</b> ${area_sqkm || "N/A"}<br />
//       `;
//       layer.bindPopup(popupContent);
//       layer.on({
//         popupopen: () => {
//           layer.setStyle({ fillOpacity: 0.5 });
//         },
//         popupclose: () => {
//           layer.setStyle({ fillOpacity: 0 });
//         },
//       });
//   }
//   // Close legend when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (legendRef.current && !legendRef.current.contains(event.target)) {
//         setLegendVisible(false);
//       }
//     };

//     if (legendVisible) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [legendVisible]);

//     // const toggleDetails = (eventName) => {
//     //     setExpandedEvent(expandedEvent === eventName ? null : eventName);
//     // };
  

//   // Helper function to create custom Leaflet icon
//   const createCustomIcon = (IconComponent) => {
//     const iconMarkup = renderToStaticMarkup(
//       <div style={{ fontSize: "32px" }}>
//         <IconComponent />
//       </div>
//     );
//     return L.divIcon({
//       html: iconMarkup,
//       className: "custom-leaflet-icon",
//     });
//   };

//   const Legend = () => {
//       return (
//           <div className="latest_event_legend">
//               <div><img src="Dashboard/Legends/cyclone.gif" width={"15px"}/> Cyclone</div>
//               <div><img src="Dashboard/Legends/landslide.gif" width={"15px"}/> Landslide</div>
//               <div><img src="Dashboard/Legends/flood.gif" width={"15px"}/> Flood</div>
//               <div><img src="Dashboard/Legends/earthquake.gif" width={"15px"}/> Earthquake</div>
//               <div><img src="Dashboard/Legends/fire.gif" width={"15px"}/> Fire</div>
//               <div><img src="Dashboard/Legends/roadaccident.gif" width={"15px"}/>  RoadAccident</div>
//           </div>
//       );
//   };
// //   const markerRefs = useRef([]);
// //   const handleTitleClick = (index) => {
// //     // Open the respective marker popup
// //     markerRefs.current[index].openPopup();
// //   };
  
//   return (
//     <>
//         <Forecast/>
//       <div className="map">
//         <div className="map-home-container">
//           <MapContainer
//             center={position}
//             zoom={8}
//             className="leaflet-home"
//             zoomControl={false}
//             scrollWheelZoom={false}
//             dragging={false}
//             doubleClickZoom={false}
//             interactive={false}
//           >
//             <div className="map-date">
//               Active Disaster Events 
//             </div>

//             {/* <TileLayer
//               url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//             /> */}
//             <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//             {/* {boundaryData && (
//               <GeoJSON
//                 data={boundaryData}
//                 style={boundaryStyle}
//                 onEachFeature={onEachFeature}
//               />
//             )} */}
          
//             {markers.map((marker, index) => {
//                 //if(marker.name === 'Earthquakes'){
//                     const icon = L.icon({
//                         iconUrl: marker.icon_name,
//                         iconSize: [30, 30], 
//                     }) ;
//                     return selectedMarkers[marker.name] ? (
//                         <Marker
//                           key={index}
//                           position={[marker.lat, marker.lon]}
//                           icon={icon}
//                         >
//                           <Popup><span>{marker.details}</span></Popup>
//                         </Marker>
//                       ) : null;
//                 // } else {
//                 //     return selectedMarkers[marker.name] ? (
                
//                 //         <Marker
//                 //           key={index}
//                 //           position={[marker.lat, marker.lon]}
//                 //           //icon={createCustomIcon(marker.icon_name)}
//                 //           icon={marker.icon_name}
//                 //         >
//                 //           <Popup>{marker.details}</Popup>
//                 //         </Marker>
//                 //       ) : null;
//                 // }
              
//             })}
//             <LayersControl position="topright" className="always-open">
//                 <LayersControl.BaseLayer name="Country" checked >
//                     {boundaryData && (
//                         <GeoJSON
//                             data={boundaryData}
//                             style={boundaryStyle}
//                             onEachFeature={onEachFeatureCountry}
//                         />
//                     )}
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer name="Municipality - 14" >
//                     {muncipalityBoundry && (
//                         <GeoJSON
//                             data={muncipalityBoundry}
//                             style={boundaryStyle}
//                             onEachFeature={onEachFeatureMuni}
//                         />
//                     )}
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer name="Sub Municipality - 71" >
//                     {subMuncipalityBoundry && (
//                         <GeoJSON
//                             data={subMuncipalityBoundry}
//                             style={boundaryStyle}
//                             onEachFeature={onEachFeatureSubMuni}
//                         />
//                     )}
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer name="Sucos - 452" >
//                     {sucoBoundaryData && (
//                         <GeoJSON
//                             data={sucoBoundaryData}
//                             style={boundaryStyle}
//                             onEachFeature={onEachFeatureSuco}
//                         />
//                     )}
//                 </LayersControl.BaseLayer>
//             </LayersControl>
//             <Legend position="bottomleft" />
           

//           </MapContainer>
//             {/* Custom Icon Container (Positioned on the left-middle of the map) */}
            
//           {/* Event Count Box */}
//           <div className="event-box">
//             <div className="text-title">Latest Events <FaCircleInfo data-tooltip-id="info-tooltip" /></div>
//             <Tooltip id="info-tooltip" className="home-tooltip" place="bottom" effect="">
//                 The latest event shows last 24 hours data.
//             </Tooltip>


//             <div className="event-list">
//                 <div className="event-item">
//                     <div className="event-main high" >
//                         <div className="event-details">
//                             Cyclone
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                         <ol className="cyclone_events_latest">
//                             <li>Name : Seroja <br/> Date: {<DateFormat date={new Date()} format="dmytime" />} <br/> Wind Speed : 120 kt</li>
//                             <li>Name : Seroja -2  <br/> Date: {<DateFormat date={new Date()} format="dmytime" />} <br/> Wind Speed : 78 kt</li>
//                         </ol>
//                     </div>
                    
//                 </div>
//                 <div className="event-item">
//                     <div className="event-main medium"  >
//                         <div className="event-details">
//                             Landslide
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                             <span>Location : Viqueque, Timor-Leste <br/> Date & Time: {<DateFormat date={new Date()} format="dmytime" />}</span>
//                         </div>
//                 </div>
//                 <div className="event-item">
//                     <div className="event-main moderate" >
//                         <div className="event-details">
//                             Earthquake
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                             <span>Location : Nitibe, Oecusse,  Timor Leste <br/> 
//                             Magnitude : 5.0 mb <br/> Depth : 42KM <br/>
//                             Longitude : 124.2860<br/>
//                             Latitude : -9.2675<br/>
//                             Date & Time: {<DateFormat date={new Date()} format="dmytime" />}</span>
//                         </div>
//                 </div>
//                 <div className="event-item">
//                     <div className="event-main low"  >
//                         <div className="event-details">
//                             Urban Flood
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                             <span>Location : Viqueque, Timor-Leste <br/> Rainfall : 65 mm <br/>Date & Time: {<DateFormat date={new Date()} format="dmytime" />}</span>
//                         </div>
//                 </div>
//                 <div className="event-item">
//                     <div className="event-main medium"  >
//                         <div className="event-details">
//                             Road Accident
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                             <span>Location : Atauro, Biqueli , Timor-Leste <br/> Type : Motorized Accident <br/> Road Condition : Sharp Curved<br/> 
//                             Blackspot : No <br/>
//                             Date & Time: {<DateFormat date={new Date()} format="dmytime" />}</span>
//                         </div>
//                 </div>
//                 <div className="event-item">
//                     <div className="event-main low" >
//                         <div className="event-details">
//                             Fire
//                         </div>
//                     </div>
//                     <div className="event-details-box">
//                             <span>Location : Fuat, Iliomar, Lautém, Timor Leste <br/> Date & Time: {<DateFormat date={new Date()} format="dmytime" />}</span>
//                         </div>
//                 </div>
//             </div>
//           </div>
//             {/* <div className="overviewdashboardpart2">
//                   <div className="activitytile">
//                     <h1 className="activitytile-title">Current Activities</h1>
//                     <div className="small-tile">
//                     {markers.map((activity, index) => (
//                         <div 
//                           key={index} 
//                           className="activitytile"
//                           onClick={() => handleTitleClick(index + markers.length)}
//                         >
//                           <h2 className="activity-heading">{activity.nameOfEvent}</h2>
//                           <p className="activity-details">
//                             Date and Time: {moment.utc(activity.dateTime).tz('Asia/Dili').format('MMMM DD, YYYY [at] h:mm A')},
//                             Location: {activity.location}
//                           </p>
//                         </div>
//                       ))}
//                     </div>
          
//                   </div>
//             </div> */}
//         </div>
//       </div>
//       <HistoricalStatistics/>
//     </>
//   );
// };
// export default Home;



import "./Home.css";

// import HistoricalStatistics from "../HistoricalStatistics/HistoricalStatistics";
// import ActiveDisaster from "../Activeevents/ActiveDisaster"
import Forecastchart from "../Forecastchart/Forecastchart";
import Forecastmap from "./Forecastmap"
import Bulletin from "./Bulletin";


const Home = () => {
  return (
    <>
    <Bulletin/>
    <Forecastmap/>
      {/* <Forecast/> */}
    
    

      {/* <div style={{ width: '100%', display: 'flex', height:'650px', margin:'10px 0px' }}>
        <div style={{ width: '50%', height:'100%' }}>
          <Forecastmini />
        </div>
      </div> */}
        
      <div className="Forecastchart">
        
        <Forecastchart/> 
      </div> 

      {/* <div className="activedisastercontainer">
      <ActiveDisaster/>
      </div>

      <HistoricalStatistics/> */}
    </>
  );
};
export default Home;